<template>
    <div v-if="loading">
        <div class="loader"></div>
    </div>
    <div v-else class="headed-table w-100">
        <table class="w-100">
            <thead>
                <tr>
                    <th class="col-6">
                        <small> Staff in Company </small>
                    </th>
                    <th class="col-2">
                        <div class="d-flex justify-content-center">
                            <small>Included on forms</small>
                        </div>
                    </th>
                    <th class="col-2">
                        <div class="d-flex justify-content-center">
                            <small>Submit forms</small>
                        </div>
                    </th>
                    <th class="col-2">
                        <div class="d-flex justify-content-center">
                            <small class="text-break">Create forms <br> & view project</small>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr class="head-table--row"  v-for="(user , index) in staff"  :key="user.id">
                    <td class="col-6">
                        <a :href="generateRouteUser(user.id)" class="people-list--item-title" target="_blank">
                            <h5 class="people-list--item-title-name">{{user.full_name}}</h5>
                            <h6 class="people-list--item-title-email">{{user.email}}</h6>
                        </a>
                    </td>

                    <td  class="col-2">
                        <div class="d-flex justify-content-center">
                            <input :disabled="user.company_role_name === 'manager'"  type="checkbox" :value="operatives_role.name" v-model="user.permissions" :true-value="operatives_role.name" :false-value="0" @change.prevent="changePermission(index,operatives_role,user)">
                        </div>
                    </td>
                    <td  class="col-2">
                        <div class="d-flex justify-content-center">
                            <input :disabled="user.company_role_name === 'manager'"  type="checkbox" :value="supervisors_role.name" v-model="user.permissions" :true-value="supervisors_role.name" :false-value="0" @change.prevent="changePermission(index,supervisors_role,user)">
                        </div>
                    </td>
                    <td  class="col-2">
                        <div class="d-flex justify-content-center">
                            <input :disabled="user.company_role_name === 'manager'"  type="checkbox" :value="managers_role.name" v-model="user.permissions" :true-value="managers_role.name" :false-value="0" @change.prevent="changePermission(index,managers_role,user)">
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import generateRoute from '../../helpers/routes';

	export default {
		name: "CompanyStaffAndPermissions",
		components: {},
		props: [
            'create_job',
            'company_staff',
            'roles',
            'store_url',
            'loading',
            'show_user_url',
        ],

        data(){
          return {
                    staff:{},
                    saving: false
                }
            },
        mounted(){
            this.staff = this.company_staff
        },

        watch: {
            company_staff() {
                this.staff = this.company_staff
            }
        },

        computed: {
            supervisors_role() {
                return this.getRole('supervisor');
            },

            operatives_role() {
                return this.getRole('operative');
            },

            managers_role() {
                return this.getRole('manager');
            }
        },

        methods: {
            generateRouteUser(userId) {
                return generateRoute(this._props.show_user_url, userId);
            },

            changePermission(index, role, user) {
                this.$set(this.staff[index], 'job_role', role.id);
            switch (role.name) {
              case 'operative':
                this.handleOperativePermission(index);
                break;
              case 'supervisor':
                this.handleSupervisorPermission(index);
                break;
              case 'manager':
                this.handleManagerPermission(index);
                break;
            }
            this.save(user);
          },

          handleOperativePermission(index) {
            if (!this.staff[index].permissions.includes('operative')) {
              this.staff[index].permissions = []
              this.staff[index].remove_from_job = true
            } else {
              this.staff[index].permissions = ['operative']
            }
          },

          handleSupervisorPermission(index) {
            if (!this.staff[index].permissions.includes('supervisor')) {
              this.staff[index].job_role = this.getRole('operative').id; // Set to operative
              this.staff[index].permissions = ['operative']
            } else {
              this.staff[index].permissions = ['supervisor', 'operative']
            }
          },

          handleManagerPermission(index) {
            if (!this.staff[index].permissions.includes('manager')) {
              this.staff[index].job_role = this.getRole('supervisor').id; // Set to supervisor
              this.staff[index].permissions = ['supervisor', 'operative']
            } else {
              this.staff[index].permissions = ['manager', 'supervisor', 'operative']
            }
          },

          getRole(role_name) {
            let return_index = null;
            this.roles.forEach((item, index) => {
              if (item.name == role_name) {
                return_index = index;
              }
            });
            if (return_index == null) {
              return null;
            }
            return this.roles[return_index];
          },

          save(user) {
            let _this = this;

            if (_this.saving) return;

            _this.saving = true;

            let data = {};
            if (user.id) {
              data.user_id = user.id;
            } else {
              data.first_name = user.first_name;
              data.last_name = user.last_name;
              data.email = user.email;
            }
            data.remove_from_job = (user.remove_from_job ?? false);
            data.role_id = user.job_role;
            data.company_role_name = user.company_role_name;

            axios.post(_this.store_url, data)
              .then(function () {
                _this.$emit('getData');
                _this.saving = false; // Reset saving status after successful request
              })
              .catch(function (e) {
                Vue.$toast.open({
                  message: 'Unable to save user against job. Please try again later',
                  type: 'error'
                });
                _this.saving = false; // Reset saving status after failed request
              })
          },
        }
    }
</script>
